// extracted by mini-css-extract-plugin
export default {"withParentName":"SsiKVPk3yP8k4cCWz-Onu"};